export interface QuestionInfo {
  parentQuestionId: string;
  questionId: string;
  rowIndex: number;
  isMatrixQuestion: boolean;
  uploadedFiles: any;
}
